import React, { ChangeEvent, useEffect, useState } from "react";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import {
  Box,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Switch,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DataService from "../../../../../Service";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
import { useDispatch } from "react-redux";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
  fieldsFilter: {
    width: 400,
    marginTop: "70px",
    padding: "10px",
  },
  fieldsFormTitle: {
    display: "flex",
    alignItems: "center",
  },
  switch: {
    "& .Mui-disabled": {
      "& .MuiSwitch-thumb": {
        color: "#EF7000",
      },
      "& + .MuiSwitch-track": {
        backgroundColor: "#EF7000",
        opacity: "0.25 ",
      },
    },
  },
});

const MIFieldsDrawer = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { parentCall, currentSelection } = props;
  const [data, setData] = useState([]);
  const [drawerFlag, setDrawerFlag] = useState({ drawerFlag: false });
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const hideFields = [
    "qa_feedback_text",
    "unsuccessful_selection_for_chemsitry",
    "unsuccessful_selection_from_chemsitry",
    "verbal_360_stakeholder_interview_names_and_dates_of_interviews",
    "total_amount_in_GBP",
  ];

  const handleText = (event) => {
    const newText = event.target.value;
    setSearchText(newText);

    const filteredData = data.filter(
      (item) =>
        !hideFields.includes(item.name) &&
        item.label.toLowerCase().includes(newText.toLowerCase())
    );
    setFilteredData(newText.trim().length > 0 ? filteredData : data);
  };
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerFlag(open);
    !open && parentCall(false);
  };

  useEffect(() => {
    fetchMIFields();
  }, []);

  const fetchMIFields = () => {
    let params = {
      organisation_id: currentSelection?.id,
    };
    setIsFormLoading(true);
    DataService.getData(params, `miFieldListForToggle`)
      .then((res) => {
        setData(res?.mi_fields || []);
        // setFilteredData(res?.mi_fields || []);
        const newData = (res?.mi_fields || []).filter((option) => {
          return !hideFields.includes(option.name);
        });

        setFilteredData(newData);
      })
      .catch((error) => {})
      .finally(() => {
        setIsFormLoading(false);
      });
  };

  const handleChange = (e, selectedField, type) => {
    setData((prev) => {
      const localArr = [...prev].map((option) => {
        if (selectedField?.id === option?.id) {
          if (type === "admin") {
            option["is_admin"] = e.target.checked;
          }
          if (type === "client") {
            option["is_client"] = e.target.checked;
          }
        }
        return option;
      });

      return localArr;
    });

    const formData = {};
    formData["organisation_id"] = currentSelection?.id;
    formData["id"] = selectedField?.id;
    const { is_admin: isAdminSelected, is_client: isClientSelected } =
      data?.find((el) => el?.id === selectedField?.id);
    formData["is_admin"] = `${isAdminSelected}`;
    formData["is_client"] = `${isClientSelected}`;

    DataService.createData(formData, "miFieldToggle")
      .then((res) => {
        if (res?.success) {
          dispatch(showSnackbar("Success", ["" + res.message], 1000));
        }
      })
      .then((error) => {});
  };

  const list = (anchor) => (
    <Box
      m={3}
      className={classes.fieldsFilter}
      style={{
        marginBottom: 0,
        marginRight: 0,
      }}
    >
      <Box style={{ position: "absolute", right: 30 }}>
        <CloseIcon
          onClick={() => parentCall(false)}
          style={{ fontSize: 18, cursor: "pointer" }}
        />
      </Box>
      <Typography
        variant="subtitle1"
        style={{ marginBottom: 15, fontSize: "18px", fontFamily: "Open Sans" }}
      >
        <Box fontWeight="fontWeightBold">
          MI fields - {currentSelection?.organisation_name}
        </Box>
      </Typography>
      <TextField
        fullWidth
        placeholder={"Search columns..."}
        variant="outlined"
        value={searchText}
        InputProps={{
          startAdornment: <SearchIcon style={{ fill: "#666" }} />,
        }}
        style={{
          width: "100%",
          fontSize: "16px",
          fontFamily: "Open Sans",
          marginBottom: "12px",
        }}
        onChange={handleText}
      />
      <FormControl
        component="fieldset"
        style={{
          display: "flex",
          fontSize: "16px",
          fontFamily: "Open Sans",
          height: "75vh",
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        <Grid
          container
          spacing={2}
          style={{
            marginBottom: "0.5rem",
            position: "sticky",
            zIndex: 1,
            background: "white",
            top: 0,
          }}
        >
          <Grid item xs={8}>
            <Typography
              variant="subtitle1"
              style={{ fontSize: "16px" }}
              color="secondary"
            >
              Column name
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography
              variant="subtitle1"
              style={{ fontSize: "16px" }}
              color="secondary"
            >
              Admin
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography
              variant="subtitle1"
              style={{ fontSize: "16px" }}
              color="secondary"
            >
              Client
            </Typography>
          </Grid>
        </Grid>
        {isFormLoading ? (
          <Box
            style={{
              width: "100%",
              height: "50vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <FormGroup>
            {filteredData?.map((option) => {
              let isDefault = option.default === "true";
              return (
                <Box>
                  <Grid container spacing={2}>
                    <Grid
                      className={classes.fieldsFormTitle}
                      item
                      xs={8}
                      style={{}}
                    >
                      <label style={{ fontSize: "16px" }}>{`${option.label}${
                        isDefault ? "*" : ""
                      }`}</label>
                    </Grid>
                    <Grid item xs={2}>
                      <FormControlLabel
                        label={""}
                        style={{ alignSelf: "flex-end" }}
                        control={
                          <Switch
                            className={option.is_admin && classes.switch}
                            checked={option.is_admin}
                            onChange={(e) => handleChange(e, option, "admin")}
                            name={`${option.field}-admin`}
                            disabled={
                              isDefault || !option.admin_enable ? true : false
                            }
                            style={{
                              cursor:
                                isDefault || !option.admin_enable
                                  ? "not-allowed"
                                  : "pointer",
                              pointerEvents: "all",
                            }}
                          />
                        }
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <FormControlLabel
                        label={""}
                        style={{ alignSelf: "flex-end" }}
                        control={
                          <Switch
                            className={option.is_client && classes.switch}
                            checked={option.is_client}
                            onChange={(e) => handleChange(e, option, "client")}
                            name={`${option.field}-client`}
                            disabled={
                              isDefault || !option.client_enable ? true : false
                            }
                            style={{
                              cursor:
                                isDefault || !option.client_enable
                                  ? "not-allowed"
                                  : "pointer",
                              pointerEvents: "all",
                            }}
                          />
                        }
                      />
                    </Grid>
                  </Grid>
                </Box>
              );
            })}
          </FormGroup>
        )}
      </FormControl>
    </Box>
  );

  return (
    <>
      <div>
        <React.Fragment>
          <SwipeableDrawer
            anchor={"right"}
            open={drawerFlag}
            onClose={toggleDrawer("drawerFlag", false)}
            onOpen={toggleDrawer("drawerFlag", true)}
          >
            {list("right")}
          </SwipeableDrawer>
        </React.Fragment>
      </div>
    </>
  );
};
export default MIFieldsDrawer;
